function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#CCD6DC",
  d: "M30 26c0 2.209-1.791 4-4 4H4c-2.209 0-4-1.791-4-4V4c0-2.209 1.791-4 4-4h22c2.209 0 4 1.791 4 4v22z"
});
var _ref3 = /*#__PURE__*/React.createElement("path", {
  fill: "#F5F8FA",
  d: "M28 26c0 1.104-.896 2-2 2H4c-1.104 0-2-.896-2-2V4c0-1.104.896-2 2-2h22c1.104 0 2 .896 2 2v22z"
});
var _ref4 = /*#__PURE__*/React.createElement("path", {
  fill: "#50A5E6",
  d: "M6 26c-.553 0-1-.448-1-1V13c0-.552.447-1 1-1s1 .448 1 1v12c0 .552-.447 1-1 1z"
});
var _ref5 = /*#__PURE__*/React.createElement("path", {
  fill: "#77B255",
  d: "M10 26c-.553 0-1-.448-1-1V8c0-.552.447-1 1-1s1 .448 1 1v17c0 .552-.447 1-1 1z"
});
var _ref6 = /*#__PURE__*/React.createElement("path", {
  fill: "#DD2F45",
  d: "M14 26c-.553 0-1-.448-1-1v-7c0-.552.447-1 1-1s1 .448 1 1v7c0 .552-.447 1-1 1z"
});
var _ref7 = /*#__PURE__*/React.createElement("path", {
  fill: "#226798",
  d: "M36 36v-2c0-3.314-2.685-6-6-6H14c-3.313 0-6 2.686-6 6v2h28z"
});
var _ref8 = /*#__PURE__*/React.createElement("path", {
  fill: "#3A87C2",
  d: "M16.667 36H20.2L17 28h-2l-1 6 3 1zm10.666 0H23.8l3.2-8h2l1 6-3 1z"
});
var _ref9 = /*#__PURE__*/React.createElement("path", {
  fill: "#F6DDCD",
  d: "M17.64 28.101c1.744 1.268 2.857 2.032 4.37 2.032 1.512 0 2.606-.766 4.35-2.032V24.29h-8.72v3.811z"
});
var _ref10 = /*#__PURE__*/React.createElement("path", {
  fill: "#ECC0AC",
  d: "M17.632 25.973c1.216 1.374 2.724 1.746 4.364 1.746 1.639 0 3.147-.373 4.363-1.746v-3.491h-8.728v3.491z"
});
var _ref11 = /*#__PURE__*/React.createElement("path", {
  fill: "#F6DDCD",
  d: "M15.445 15.936c0 1.448-.734 2.622-1.639 2.622s-1.639-1.174-1.639-2.622.734-2.623 1.639-2.623 1.639 1.174 1.639 2.623m16.388 0c0 1.448-.733 2.622-1.639 2.622-.905 0-1.639-1.174-1.639-2.622s.733-2.623 1.639-2.623 1.639 1.174 1.639 2.623"
});
var _ref12 = /*#__PURE__*/React.createElement("path", {
  fill: "#F6DDCD",
  d: "M13.478 16.96c0-5.589 3.816-10.121 8.523-10.121s8.523 4.532 8.523 10.121-3.816 10.121-8.523 10.121c-4.707-.001-8.523-4.532-8.523-10.121"
});
var _ref13 = /*#__PURE__*/React.createElement("path", {
  fill: "#C1694F",
  d: "M22 23.802c-2.754 0-3.6-.705-3.741-.848-.256-.256-.256-.671 0-.927.248-.248.646-.255.902-.023.052.037.721.487 2.839.487 2.2 0 2.836-.485 2.842-.49.256-.255.657-.243.913.015.256.256.242.683-.014.938-.141.143-.987.848-3.741.848m.75-4.052h-1.5c-.413 0-.75-.337-.75-.75s.337-.75.75-.75h1.5c.413 0 .75.337.75.75s-.337.75-.75.75"
});
var _ref14 = /*#__PURE__*/React.createElement("path", {
  fill: "#662213",
  d: "M26 17c-.55 0-1-.45-1-1v-1c0-.55.45-1 1-1s1 .45 1 1v1c0 .55-.45 1-1 1m-8 0c-.55 0-1-.45-1-1v-1c0-.55.45-1 1-1s1 .45 1 1v1c0 .55-.45 1-1 1"
});
var _ref15 = /*#__PURE__*/React.createElement("path", {
  fill: "#292F33",
  d: "M22 3.48c5.648 0 9.178 4.168 9.178 7.641s-.706 4.863-1.412 3.473l-1.412-2.778s-4.235 0-5.647-1.39c0 0 2.118 4.168-2.118 0 0 0 .706 2.779-3.53-.694 0 0-2.118 1.389-2.824 4.862-.196.964-1.412 0-1.412-3.473C12.822 7.648 15.646 3.48 22 3.48"
});
var _ref16 = /*#__PURE__*/React.createElement("path", {
  fill: "#CCD6DC",
  d: "M20.461 36H24l2-4-3.99-1.867L18 32l2 4z"
});
var _ref17 = /*#__PURE__*/React.createElement("path", {
  fill: "#9F1D22",
  d: "M22.031 33.957c.744 0 1.246 1.025 1.562 2.043h.549c-.394-1.262-.841-2.438-.841-2.438s.375-.625.531-.906c.184-.33.453-1.57.453-1.57l-2.188-.963c0-.006-.16.006-.16.006l-.184.043-.172.062c-.217.07.094.008.094.014l-1.973.838s.287 1.24.469 1.57c.156.281.529.906.529.906s-.43 1.106-.797 2.438h.559c.319-1.018.826-2.043 1.569-2.043z"
});
var _ref18 = /*#__PURE__*/React.createElement("path", {
  fill: "#DD2F45",
  d: "M22.031 33.957c-.744 0-1.25 1.025-1.57 2.043h3.132c-.316-1.018-.818-2.043-1.562-2.043zm-.027-3.144c.391-.023 1.543.771 1.422 1.25-.461 1.826-.848 1.391-1.391 1.391-.611 0-.963.473-1.391-1.312-.091-.388.797-1.298 1.36-1.329"
});
var _ref19 = /*#__PURE__*/React.createElement("path", {
  fill: "#F4F7F9",
  d: "M26.719 26.75c-.567.566-4.709 3.383-4.709 3.383s2.127 1.242 4.084 3.533c.197.23 1.543-4.625 1.584-5.709.011-.303-.688-1.478-.959-1.207m-9.418 0c.566.566 4.709 3.383 4.709 3.383s-2.127 1.242-4.084 3.533c-.197.23-1.543-4.625-1.584-5.709-.012-.303.687-1.478.959-1.207"
});
var SvgAgenteIcon = function SvgAgenteIcon(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, ["svgRef", "title"]);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 36 36",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19);
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAgenteIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/agente-icon.47fc48cd.svg";
export { ForwardRef as ReactComponent };